import React, { Fragment } from "react";
import { Modal } from "react-bootstrap";

export type Title = string | React.ReactNode[] | JSX.Element[] | string[];
export type MultilineTitleProps = { title: Title; className?: string };

const MultilineTitle: React.FC<MultilineTitleProps> = ({
	title,
	className,
}) => {
	if (typeof title === "string") {
		return <Modal.Title className={className}>{title}</Modal.Title>;
	}

	const [firstLine, ...restLines] = title;

	return (
		<Modal.Title className={className}>
			{firstLine}
			{restLines?.map((line, index) => (
				<Fragment key={index}>
					<br />
					{line}
				</Fragment>
			))}
		</Modal.Title>
	);
};

export default MultilineTitle;
